export default "__VITE_ASSET__1db03059__"